import { createSlice } from '@reduxjs/toolkit';

const initialState = {
  servicios: [],
  fetchServiciosLoading: false,
  fetchServiciosError: null,

  addServicioLoading: false,
  addServicioError: null,

  updateServicioLoading: false,
  updateServicioError: null
};

export const serviciosSlice = createSlice({
  name: 'SERVICIOS',
  initialState,
  reducers: {
    fetchServiciosStart: state => {
      state.fetchServiciosLoading = true;
      state.fetchServiciosError = null;
    },
    fetchServiciosSuccess: (state, action) => {
      state.fetchServiciosLoading = false;
      state.servicios = action.payload;
    },
    fetchServiciosError: (state, action) => {
      state.fetchServiciosLoading = false;
      state.fetchServiciosError = action.payload;
    },

    addServicioStart: state => {
      state.addServicioLoading = true;
      state.addServicioError = null;
    },
    addServicioSuccess: (state, action) => {
      state.addServicioLoading = false;
      state.servicios.push(action.payload);
    },
    addServicioError: (state, payload) => {
      state.addServicioLoading = false;
      state.addServicioError = payload.error;
    },

    updateServicioStart: state => {
      state.updateServicioLoading = true;
      state.updateServicioError = null;
    },
    updateServicioSuccess: (state, action) => {
      state.updateServicioLoading = false;
      const newArray = state.servicios.map(serv => {
        if (serv.id === action.payload.id) return action.payload;
        return serv;
      });
      state.servicios = newArray;
    },
    updateServicioError: (state, payload) => {
      state.updateServicioLoading = false;
      state.updateServicioError = payload.error;
    }
  }
});

export const {
  fetchServiciosStart,
  fetchServiciosSuccess,
  fetchServiciosError,
  addServicioStart,
  addServicioSuccess,
  addServicioError,
  updateServicioStart,
  updateServicioSuccess,
  updateServicioError
} = serviciosSlice.actions;

export default serviciosSlice.reducer;
